package common.constants

object Server {
    private val allServers = arrayOf(
        "https://solute-rest-v3-cg5klytkca-ew.a.run.app",
        "http://192.168.29.232:8080",
        "https://solute-rest-v3-cg5klytkca-ew.a.run.app",
        "https://solute-rest-v3-cg5klytkca-ew.a.run.app",
    )

    fun getRestApiEndPoint(): String {
        return allServers[0] + "/api/"
    }

    fun getRestApiEndPointFor(api: String): String {
        return allServers[0] + "/api/$api"
    }
}
